import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";
import { Link, type LinkProps, LinkType } from "~/common/components/Link";
import { forwardRef } from "react";
import { useProductDetailsUrl } from "~/common/components/PackageRestrictionContext/useProductDetailsUrl";
import type { PurchasePlace, PurchaseType } from "~/feature/Analytics/ga/recommendations/types";

interface Props extends LinkProps, BaseProductElementProps {
  reco_type?: PurchaseType;
  reco_place?: PurchasePlace;
  additionalParams?: Record<string, string>;
}

export const PdpLink = forwardRef<HTMLAnchorElement, Props>(
  ({ href: externalHref, reco_type, reco_place: external_reco_place, additionalParams, ...props }, ref) => {
    const product = useProductContext(props);

    let href: string | undefined = useProductDetailsUrl(product, reco_type, external_reco_place, additionalParams);
    if (externalHref) {
      href = externalHref;
    }

    return <Link href={href} ref={ref} variant={LinkType.SECONDARY} {...props} />;
  },
);
